export default __webpack_public_path__ + "static/media/eas_bg_large.b3228123.jpg";